<template>
  <div class="is-expanded">
    <DesktopTable
      :tokens-for-trade="tokensForTrade"
      class="is-hidden-touch"
      @buyEvent="buy"
      @sellEvent="sell"
    />
    <MobileCard
      :tokens-for-trade="tokensForTrade"
      class="is-hidden-desktop"
      @buyEvent="buy"
      @sellEvent="sell"
    />
    <b-modal
      id="buy-sell-modal"
      :active.sync="isBuySellModalActive"
      :full-screen="isMobile"
      :can-cancel="['escape', 'outside']"
      scroll="keep"
    >
      <Trading
        :modal-from-token="fromToken"
        :modal-to-token="toToken"
        type="BuySellModal"
        @onClickExchange="onClickExchange"
      />
    </b-modal>
  </div>
</template>

<script>
/**
 * TokenProfile Component
 */

import DesktopTable from './components/DesktopTable'
import MobileCard from './components/MobileCard'
import Trading from '@/features/Trading'
import { mapGetters } from 'vuex'

export default {
  name: 'TokenProfile',
  components: {
    DesktopTable,
    MobileCard,
    Trading
  },
  service: null,
  data () {
    return {
      windowWidth: window.innerWidth,
      isBuySellModalActive: false,
      fromToken: null,
      toToken: null
    }
  },
  computed: {
    ...mapGetters({
      tokensForTrade: 'tokensForTrade'
    }),
    ethObj () {
      if (this.tokensForTrade.length) {
        return this.tokensForTrade.find(data => data.code === 'ETH')
      } else {
        return {}
      }
    },
    daiObj () {
      if (this.tokensForTrade.length) {
        return this.tokensForTrade.find(data => data.code === (process.env.ETH_NETWORK === 'kovan' ? 'DAI-UNI' : 'DAI'))
      } else {
        return {}
      }
    },
    isMobile () {
      return this.windowWidth <= 768
    }
  },
  mounted () {
    window.addEventListener('resize', this.onWindowResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.onWindowResize)
  },
  methods: {
    buy (target) {
      this.isBuySellModalActive = true
      if (target.code === 'ETH') {
        this.fromToken = this.daiObj
      } else {
        this.fromToken = this.ethObj
      }
      this.toToken = target
    },
    sell (source) {
      this.isBuySellModalActive = true
      this.fromToken = source
      if (source.code === 'ETH') {
        this.toToken = this.daiObj
      } else {
        this.toToken = this.ethObj
      }
    },
    onClickExchange () {
      this.isBuySellModalActive = false
    },
    onWindowResize () {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>

<style>
#buy-sell-modal .modal-content {
  overflow: hidden !important;
  max-width: 530px !important;
}
</style>



// WEBPACK FOOTER //
// src/features/TokenProfile/index.vue